/** Modes in which the dropdown filter can be shown. */
export const DROPDOWN_FILTER_MODES = Object.freeze({
  multiselect: "multiselect",
  default: "default",
});
